import { Component, OnInit } from '@angular/core';
import { ChauffeurService } from 'src/app/_services/RH-service/chauffeur/chauffeur.service';
import { NotifService } from 'src/app/_services/notif.service';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-chauffeur-detail',
  templateUrl: './chauffeur-detail.component.html',
  styleUrls: ['./chauffeur-detail.component.scss']
})
export class ChauffeurDetailComponent implements OnInit {

  driver:any;
  url;
  
  constructor(
    private ChauffeurService: ChauffeurService,
    private notifService: NotifService,
    private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,

  ) { }

  async ngOnInit() {
    const driverId = +this.route.snapshot.paramMap.get("id");
     console.log(driverId);
    this.ChauffeurService.find(driverId).then(
      data => {
        this.driver = data;
        console.log(this.driver)
      }
    ).catch(
      error => {
        this.translate.get('Driver.'+error.error.code)
        .subscribe(val => this.notifService.danger(val));
        this.router.navigate(['/chauffeur/all'])
      }
    )
  }

}
